import ResourceManager from "@/components/app/ResourceManager";
import { Badge } from "@/components/ui/badge";

const config = {
  endpoint: "agents",
  testid: "agents",
  singular: "Agent",
  overline: "Loan Backend",
  title: "Normal DSA / Agents",
  subtitle: "Direct selling agents who source loan business.",
  accent: "loan",
  documentsEntity: "agent",
  perms: { add: "agents.add", edit: "agents.edit", delete: "agents.delete" },
  columns: [
    { key: "name", label: "Agent", render: (r) => <span className="font-medium text-zinc-900">{r.name}</span> },
    { key: "agent_id", label: "Agent ID", badge: true },
    { key: "firm_name", label: "Firm" },
    { key: "mobile", label: "Mobile" },
    { key: "default_commission_share", label: "Share %", render: (r) => `${r.default_commission_share || 0}%` },
    { key: "active", label: "Status", render: (r) => (
      <Badge variant="outline" className={`rounded-sm font-normal ${r.active ? "border-emerald-500 text-emerald-600" : "border-zinc-300 text-zinc-400"}`}>{r.active ? "Active" : "Inactive"}</Badge>
    )},
  ],
  fields: [
    { name: "name", label: "Agent Name", type: "text", required: true, section: "Basic" },
    { name: "firm_name", label: "Company / Firm", type: "text", section: "Basic" },
    { name: "mobile", label: "Mobile", type: "text", section: "Basic" },
    { name: "email", label: "Email", type: "email", section: "Basic" },
    { name: "pan", label: "PAN", type: "text", section: "Basic" },
    { name: "gstin", label: "GSTIN", type: "text", section: "Basic" },
    { name: "joining_date", label: "Date of Joining", type: "date", section: "Basic" },
    { name: "default_commission_share", label: "Default Commission Share (%)", type: "number", section: "Basic" },
    { name: "address", label: "Address", type: "textarea", section: "Basic" },
    { name: "account_holder", label: "Account Holder", type: "text", section: "Banking" },
    { name: "bank_name", label: "Bank Name", type: "text", section: "Banking" },
    { name: "account_number", label: "Account Number", type: "text", section: "Banking" },
    { name: "ifsc", label: "IFSC", type: "text", section: "Banking" },
    { name: "upi_id", label: "UPI ID", type: "text", section: "Banking" },
    { name: "remarks", label: "Remarks", type: "textarea", section: "Banking" },
    { name: "active", label: "Active", type: "switch", section: "Banking" },
  ],
};

export default function Agents() {
  return <ResourceManager config={config} />;
}
